<template>
    <div class="dialog-container" v-if="isShow" @click="onClose">
        <div class="container" @click.stop="onStop">
            <img
                class="close-btn"
                @click="onClose"
                src="https://res.peki.vip/20220302/d24bf7bf04914a0d8c114b8148a779e2.png"
            />
            <div class="title">佩琪翻译公众号</div>
            <img src="https://res.peki.vip/20220302/8f1439c3ed7e41e3a97bf9ab887b13b3.png" />
            <div class="desc">{{ desc }}</div>
            <div class="desc">了解更多CATTI备考资讯</div>
        </div>
    </div>
</template>
<script>
import { isWeixin } from '@/utils/utils.js'

export default {
    data() {
        return {
            desc: '',
            isShow: false,
        }
    },
    methods: {
        onStop() {},
        onShow() {
            if (isWeixin()) {
                this.desc = '长按识别二维码关注公众号'
            } else {
                this.desc = '打开 微信 - 扫一扫，扫码二维码关注公众号'
            }
            try {
                let timeStamp = localStorage.getItem('officialaccountTime')
                timeStamp = parseInt(timeStamp)
                if (!timeStamp) {
                    this.isShow = true
                    localStorage.setItem('officialaccountTime', Date.now())
                } else if (Date.now() - timeStamp > 6 * 60 * 60 * 1000) {
                    this.isShow = true
                    localStorage.setItem('officialaccountTime', Date.now())
                }
            } catch (error) {
                this.isShow = true
            }
        },
        onClose() {
            this.isShow = false
        },
    },
}
</script>
<style lang="scss" scoped>
.dialog-container {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
.container {
    width: 300px;
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    position: relative;
    .close-btn {
        margin: 0;
        width: 18px;
        height: 18px;
        padding: 12px;
        position: absolute;
        top: 6px;
        right: 6px;
        cursor: pointer;
    }
    .title {
        font-size: 18px;
        text-align: center;
    }
    img {
        width: 240px;
        height: 240px;
        margin: 20px 0 12px;
    }
    .desc {
        font-size: 12px;
        color: #888;
        line-height: 1.6em;
        text-align: center;
    }
}
</style>
